import React from "react";
import { DateTimePicker } from "@mantine/dates";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import "dayjs/locale/en";

// Extend dayjs with advancedFormat plugin
dayjs.extend(advancedFormat);
dayjs.locale("en");

// Calendar Icon Component
const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 0V2H13V0H15V2H19C19.5523 2 20 2.44772 20 3V19C20 19.5523 19.5523 20 19 20H1C0.44772 20 0 19.5523 0 19V3C0 2.44772 0.44772 2 1 2H5V0H7ZM18 10H2V18H18V10ZM6 12V14H4V12H6ZM11 12V14H9V12H11ZM16 12V14H14V12H16ZM5 4H2V8H18V4H15V6H13V4H7V6H5V4Z"
      fill="black"
    />
  </svg>
);

const dateTimeInputStyles = {
  label: {
    fontSize: "16px",
    fontWeight: 700,
  },
  input: {
    fontSize: "18px",
    "--input-padding-y": "0px",
    "--input-padding-x": "8px",
    "::placeholder": {
      fontSize: "18px",
      color: "#AAAAAA",
    },
  },
};

export default function DateTimeInputField({ name, value, onChange, ...props }) {
  return (
    <DateTimePicker
      styles={dateTimeInputStyles}
      valueFormat="Do MMMM, h:mm A"
      clearable
      rightSection={<CalendarIcon />}
      popoverProps={{
        zIndex: 10003,
      }}
      value={value}
      onChange={(val) => onChange(name, val)}
      {...props}
    />
  );
}
